module.exports = __webpack_public_path__ + "assets/img/50.fa059b91.png";